export const authKey = 'AIzaSyCOcUCI2YMZXtVJkuOcYMAttj8XXDMyR7M';
